import fetchAlchemySolution from '../services/fetchAlchemySolution';
import sendAlchemyDataPoint from '../services/sendAlchemyDataPoint';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { AlchemyClassifyResponse } from '../schema/AlchemyClassifyResponse';
import createAlchemyClientContext from '../utils/createAlchemyClientContext';
import { trace } from 'owa-trace';

export default async function getAlchemySolution(
    invokedBy: string,
    userText?: string,
    clientContextJson?: string
): Promise<AlchemyClassifyResponse> {
    let alchemyResponse: AlchemyClassifyResponse;
    let alchemyBucketId: string = 'EmptyBucket';
    let alchemyId: string = 'EmptyId';

    let userConfig = getUserConfiguration();

    let clientContext = isClientContextValid(clientContextJson)
        ? clientContextJson
        : createAlchemyClientContext(userConfig, invokedBy);

    alchemyResponse = await fetchAlchemySolution({
        UserId: '',
        ClientContext: clientContext,
        Locale: userConfig.SessionSettings.UserCulture,
        Text: userText,
        ContextualData: {},
    });

    if (alchemyResponse && alchemyResponse.AlchemySolution) {
        if (alchemyResponse.AlchemySolution.AlchemyId) {
            alchemyId = alchemyResponse.AlchemySolution.AlchemyId;
        }
        if (alchemyResponse.AlchemySolution.AlchemyBucketId) {
            alchemyBucketId = alchemyResponse.AlchemySolution.AlchemyBucketId;
        }
    }

    sendAlchemyDataPoint({
        alchemyId: alchemyId,
        clientContext: clientContext,
        locale: userConfig.SessionSettings.UserCulture,
        alchemyBucketId: alchemyBucketId,
    });

    return alchemyResponse;
}

export function isClientContextValid(clientContextJson?: string): boolean {
    if (clientContextJson) {
        try {
            JSON.parse(clientContextJson);
            return true;
        } catch (e) {
            trace.warn(`getAlchemySolution: Invalid client context ${clientContextJson}`);
        }
    }

    return false;
}
